module.exports = __webpack_public_path__ + "img/full-screen--off.b859cce1.svg";